import { axiosGet } from 'shared/api/axios'
import { apiUrls } from 'consts'
import ActionButtons from 'shared/components/ActionButtons'

interface getRowsProps {
  setShowModal: Function
}

const getRows = async (props: getRowsProps) => {
  const getParams = {}

  const response = await axiosGet(apiUrls.emailTemplates, getParams)

  const data = response.data

  data.forEach((row: any, index: number, dataArray: any) => {
      dataArray[index].action = (
        <ActionButtons
          buttons={[
            {
              type: 'u',
              url: '/edit-email-template/' + row.id
            }
          ]}
        />
      )
  })

  return data
}

export default getRows
